<template>
  <div id="contact">
    <van-row>
      <van-col span="24" class="contact_type">
        <!-- 输入任意文本 -->
        <van-field v-model="weixin_account" :label="$t('column.wechat_number')" />
        <!-- 输入任意文本 -->
        <van-field v-model="weixin_prop_sum" type="number" :label="$t('column.number_of_gifts')" />
        <!-- 允许输入数字，调起带符号的纯数字键盘 -->
        <van-col span="22" offset="1" class="contact_type_name">{{ $t('column.choose_wechat_gift')}}</van-col>
        <van-col span="22" offset="1">
          <van-col v-for="(p) in prop" :key="p.id" span="6" :class="weixin_propid==p.id ? 'contact_type_pad contact_bg' : 'contact_type_pad'" @click="weixin_prop(p.id)">
            <van-col span="24" class="contact_type_img">
              <img :src="p.icon"/>
            </van-col>
            <van-col span="24" class="contact_type_prop_diamonds"> {{ p.diamonds }}</van-col>
            <van-col span="24" class="contact_type_prop_name"> {{ p.name }}</van-col>
          </van-col>
        </van-col>
        <!-- 提交按钮 -->
        <van-col span="18" offset="3" @click="contact_btn" class="contact_btn">{{ $t('btn.preservation')}}</van-col>
      </van-col>
    </van-row>

  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        weixin_account: '',
        weixin_propid: '',
        weixin_prop_sum: '',
        prop: []
      }
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.set_up_contact')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_center&act=get_contact", {
          params : {
            token: token
          }
        }).then(res =>{
            console.log(res.data)
            this.weixin_account = res.data.data.user_info && res.data.data.user_info.weixin_account ? res.data.data.user_info.weixin_account : ''
            this.weixin_propid = res.data.data.user_info && Number(res.data.data.user_info.weixin_propid) ? res.data.data.user_info.weixin_propid : ''
            this.weixin_prop_sum = res.data.data.user_info && Number(res.data.data.user_info.weixin_prop_sum) ? res.data.data.user_info.weixin_prop_sum : ''
            this.prop = res.data.data.prop
        })
      },
      contact_btn () {
        if(!this.weixin_account){
          Toast(this.$t('Tips.please_set_micro_signal'));
          return false
        }
        if(!this.weixin_prop_sum){
          Toast(this.$t('Tips.select_number_gifts'));
          return false
        }
        if(!this.weixin_propid){
          Toast(this.$t('Tips.please_choose_wechat_gift'));
          return false
        }
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_center&act=save_contact", {
          params : {
            token: token,
            weixin_account: this.weixin_account,
            weixin_propid: this.weixin_propid,
            weixin_prop_sum: this.weixin_prop_sum
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error);
          if (res.data.status == 1) {
            this.convert()
          }
        })
      },
      weixin_prop (id) {
        this.weixin_propid = id
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contact.vue